import { LaunchDarklySettingsModel } from "@MasterBluePrint/Types/ApiModels";
import { initialize, LDClient } from "launchdarkly-js-client-sdk";

let ldClient: LDClient | null = null;

const initializeLDClient = (clientId: string): Promise<void> => {
    if(!ldClient) {
        ldClient = initialize(clientId, { key : 'anonymous-user'});

        return new Promise((resolve) => {
            ldClient?.on('ready', () => {
            // Mark as initialized
            resolve();
          });
        });
    }
    return Promise.resolve();
}

export const getFeatureFlag = async (customSettings: LaunchDarklySettingsModel, flagKey: string): Promise<boolean> => {
    if (customSettings?.useLaunchDarkly) {
        await initializeLDClient(customSettings.launchDarklyClientId);
        if (ldClient) { 
            return ldClient?.variation(flagKey, false);
        }
        return Promise.resolve(false);
        
    }
    return Promise.resolve(false);
}

const getflagsync = (customSettings: LaunchDarklySettingsModel, flagKey: string): Promise<boolean> => {
    return getFeatureFlag(customSettings, flagKey)
    .then((flagvalue) => {return flagvalue})
    .catch(() => {return false; });
}